import React from 'react';
import { func, number, shape, string } from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

export default function PanelNavControl({
  handleCategorySelect,
  nextCategory,
  prevCategory
}) {
  if (!prevCategory && !nextCategory) return null;

  return (
    <ButtonGroup className="panel-nav-control">
      {/* eslint-disable jsx-a11y/tabindex-no-positive */}
      <Button
        bsStyle="warning"
        disabled={!prevCategory}
        onClick={handleCategorySelect(prevCategory)}
        tabIndex="8"
      >
        <FontAwesome name="chevron-left" tag="i" className="inline-block" />
        {' Prev'}
      </Button>
      <Button
        bsStyle="warning"
        disabled={!nextCategory}
        onClick={handleCategorySelect(nextCategory)}
        tabIndex="9"
      >
        {/* eslint-enable jsx-a11y/tabindex-no-positive */}
        {'Next '}
        <FontAwesome name="chevron-right" tag="i" className="inline-block" />
      </Button>
    </ButtonGroup>
  );
}

PanelNavControl.propTypes = {
  handleCategorySelect: func.isRequired,
  nextCategory: shape({
    label: string,
    value: number
  }),
  prevCategory: shape({
    label: string,
    value: number
  })
};

PanelNavControl.defaultProps = {
  nextCategory: undefined,
  prevCategory: undefined
};
